import { useEffect } from "react";


//
const YourmapLeafletContainerUniversal = (props) => {
  /*
  let _cbGoBack = () => { };
  if (typeof props._cbGoBack === 'function') {
    // props?._cbGoBack?.()
    _cbGoBack = props._cbGoBack;
  }
  */

  useEffect(() => {
    // this will be executet on component mount
    console.log('-------- *** useEffect for yourmapscript.init');

    //
    let options = props.options;

    // const position = [51.505, -0.09];
    // 38.8765507,-77.1141811
    // const ll = [38.8765507, -77.1141811]; // lat long (latitude, longtitude)
    const ll = props.ll; // lat long (latitude, longtitude)
    const zoom = props.zoom; // lat long (latitude, longtitude)
    if (window.yourmapscript && typeof window.yourmapscript.init === 'function') {
      console.log(typeof window.yourmapscript);
      console.log(window.yourmapscript);
      window.yourmapscript.init(ll, zoom, options);
    } else {
      console.log('ERROR window.yourmapscript.init function NOT FOUND');
    }
  }, []);

  return (
    <div className="yourmap__map-widget-pack__map-target" id="map-dom-target">
      <div className="IF_YOU_SEE_THIS_MAP_IS_NOT_RENDERED">IF YOU SEE THIS MAP IS NOT RENDERED - Refresh page</div>
    </div>
  );
};


export default YourmapLeafletContainerUniversal;